import axiosInstance from 'api/axiosInstance'

export const getSubscriptions = async (
  filter: number,
  type: 'active' | 'expired' = 'active',
  sort: number = 1,
  currentPage: number = 1,
  search?: string
) => {
  try {
    const { data } = await axiosInstance({
      method: 'GET',
      url: `/api/user/subscriptions/${type}`,
      params: {
        filter,
        sort,
        page: currentPage,
        search: search?.trim() ?? undefined
      }
    })

    return {
      nextCursor:
        currentPage < data?.meta?.last_page
          ? currentPage + 1
          : undefined,
      prevCursor: currentPage > 1 ? currentPage - 1 : undefined,
      page: {
        data
      }
    }
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

export const getSubscriptionModels = async (listId?: string) => {
    try {
        const { data } = await axiosInstance({
            method: 'GET',
            url: '/api/user/active-subs',
            params: listId ? { list_id: listId } : {}
        })

        return data?.data ?? []
    } catch (error) {
        console.error('Error:', error)
        return []
    }
}